// =============================================================================
// components/learn/gradients.ts — shared palette for the Learn with CRYB cards.
//
// Vivid gradient covers within the app's purple/lavender identity plus a couple
// of accent blends. Cards cycle through CARD_GRADIENTS by index so a level's
// step list reads as a colorful, varied deck (the old-app look the client
// loves) while staying on-palette.
// =============================================================================

export type Gradient = readonly [string, string];

export const CARD_GRADIENTS: readonly Gradient[] = [
  ['#6C5CE7', '#A855F7'], // core CRYB purple
  ['#8E7CF8', '#C084FC'], // soft lavender
  ['#7F5AF0', '#5B8DEF'], // purple → blue accent
  ['#A855F7', '#EC4899'], // purple → pink accent
  ['#5B4BC4', '#8B5CF6'], // deep violet
  ['#6C5CE7', '#48C6EF'], // purple → sky accent
] as const;

export function gradientFor(index: number): Gradient {
  return CARD_GRADIENTS[((index % CARD_GRADIENTS.length) + CARD_GRADIENTS.length) % CARD_GRADIENTS.length];
}

// The three learner levels. The backend stores difficulty as
// 'beginner' | 'intermediate' | 'advanced' (nullable) — 'advanced' surfaces in
// the UI as "Expert" (the reference design's label). Articles without a
// difficulty land in Beginner so nothing published ever disappears.
export type LearnLevel = 'beginner' | 'intermediate' | 'advanced';

export const LEARN_LEVELS: readonly { value: LearnLevel; label: string }[] = [
  { value: 'beginner', label: 'Beginner' },
  { value: 'intermediate', label: 'Intermediate' },
  { value: 'advanced', label: 'Expert' },
] as const;

export function levelLabel(value: string | null | undefined): string {
  const found = LEARN_LEVELS.find((l) => l.value === (value || 'beginner'));
  return (found || LEARN_LEVELS[0]).label;
}
